import Ajax from '../util/ajax';
export function actionLevel(id, value) {
    return (dispatch) => {
        const a = new Ajax(dispatch, true);
        a.post('/action/' + id + '/exec', value);
    };
}
